import React from "react";
import PropTypes from "prop-types";

const DropletIcon = ({
  className,
  width,
  size,
  height,
  style,
  color,
  noPointer,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 17}
    height={height || size || 21}
    viewBox="0 0 17 21"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "black"}
    stroke={color || "black"}
  >
    <title>{title}</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="droplet-icon" fill="none" fillRule="evenodd">
        <path d="M-3-1h24v24H-3z" />
        <path
          fill="#57595D"
          fillRule="nonzero"
          d="M3.238 6.42L8.11 1.248a1.084 1.084 0 0 1 1.58 0l4.872 5.172a8.348 8.348 0 0 1 1.745 2.784 8.985 8.985 0 0 1 .593 3.217 8.946 8.946 0 0 1-.593 3.217 8.366 8.366 0 0 1-1.745 2.777 7.849 7.849 0 0 1-2.626 1.858 7.605 7.605 0 0 1-3.036.634 7.605 7.605 0 0 1-3.036-.634 7.85 7.85 0 0 1-2.626-1.858 8.459 8.459 0 0 1-1.742-2.78A8.91 8.91 0 0 1 .9 12.42a8.94 8.94 0 0 1 .596-3.217A8.45 8.45 0 0 1 3.238 6.42zM8.9 3.334l-4.276 4.54A6.414 6.414 0 0 0 3.306 9.98a6.773 6.773 0 0 0-.453 2.44c0 .837.15 1.65.45 2.436.3.787.74 1.488 1.32 2.104a5.934 5.934 0 0 0 1.984 1.404 5.737 5.737 0 0 0 4.59 0c.739-.32 1.399-.787 1.98-1.404a6.33 6.33 0 0 0 1.32-2.1c.3-.785.45-1.598.45-2.44 0-.837-.15-1.65-.45-2.44a6.312 6.312 0 0 0-1.32-2.108L8.9 3.333z"
        />
      </g>
    </g>
  </svg>
);
DropletIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default DropletIcon;
